const BookActions = {
  ADD_BOOK: 'ADD_BOOK',
  REMOVE_BOOK: 'REMOVE_BOOK',
  FETCH_BOOKS: 'FETCH_BOOKS',
};

export default BookActions;
